angular.module('rjmNg.services').factory 'rjql', [
  "$http"
  "$q"
  "phpServiceUrl"
  "encodedLetterString"
  "rjqlFormula"
  "dataPerspective"
  "operatorEnums"
  "timeRangeEnums"
  "metricDataTypes"
  "rjqlStringConstants"
  "serviceUrl"
  "promiseCache"
  "utils"
  (
    $http,
    $q,
    phpServiceUrl,
    encodedLetterString,
    rjqlFormula,
    dataPerspective,
    operatorEnums,
    timeRangeEnums,
    metricDataTypes,
    rjqlStringConstants,
    serviceUrl
    promiseCache
    utils
  ) ->

    # Detect if we can create a single source query
    _isSingleSource = (sources) ->
      sources.length is 1 and sources[0].type is 'metric'

    _getVisibleSources = (sources) ->
      metric for metric in sources when metric.plot isnt false

    _allSourcesHidden = (sources) ->
      hiddenSources = (metric for metric in sources when not metric.plot)
      if hiddenSources.length is sources.length then return true

    hasPeriodDiffColumn = (columns) ->
      return if columns?[0]?.function? then columns[0].function is "perioddiff" else false

    _generateSelect = (sources, rows, columns, version=0.1) ->
      isSingleSource = _isSingleSource(sources)
      visibleSources = _getVisibleSources(sources)
      timeInterval = _getTimeInterval(columns)
      isCohort = hasPeriodDiffColumn(columns)
      if _allSourcesHidden(sources)
        select =
          measures: []
          columns: []
        return select

      allSourcesMeasures = sources.map (s) ->
        if s.type isnt 'formula'
          dataPerspective.getPerspectiveMeasure(s, isSingleSource, timeInterval, version, rows)
        else
          # this is just a placeholder so that we can properly index the expression
          # components. Formula sources can never be used in other formulas
          s.alias

      select =
        measures: for source in visibleSources
          if source.type is 'formula'
            dataType = if source.assignedType?.type? then source.assignedType.type else metricDataTypes.DATA_TYPES.nonMonetary
            currencyCode = if dataType is metricDataTypes.DATA_TYPES.currency then source.assignedType?.currencyCode else null

            type: source.type
            expression: rjqlFormula.getExpressionWithMeasures(source.expressionText, allSourcesMeasures, version)
            label: source.alias
            dataType: dataType
            currencyCode: currencyCode
          else if source.perspective?
            dataPerspective.getPerspectiveMeasure(source, isSingleSource, timeInterval, version, rows)

      if rows?
        if isSingleSource
          select.rows = []
          for row, index in rows
            if isCohort and sources[0]?.dimensions[index].datatype is "DATETIME"
              select.rows.push(
                interval:
                  unit: timeInterval
                  value: 1
                time: sources[0]?.dimensions[index].column_id
              )
            else
              select.rows.push(sources[0]?.dimensions[index].column_id)
        else
          select.rows = for row in rows
            row.name

      if columns
        select.columns ?= []
        for column in columns
          select.columns.push _setTimeKeyword(column, isSingleSource)

      return select

    _setTimeKeyword = (column, isSingleSource) ->
      if column.alias isnt rjqlStringConstants.RJQL_PERIODDIFF
        column.time = dataPerspective.getTimeKeyword(isSingleSource)
      return column

    _getTimeInterval = (columns) ->
      if columns? and columns.length > 0
        return columns[0].interval or columns[0].args?[2] # second check is for cohorts
      else
        return timeRangeEnums.TIME_INTERVAL_VALUES.NONE

    _getTimeBind = () ->
      time: rjqlStringConstants.RJQL_TIME

    _generateFrom = (sources, rows, columns, showAllGroupByValues, version) ->
      bind = undefined
      timerange = undefined
      isSingleSource = _isSingleSource(sources)
      timeInterval = _getTimeInterval(columns)

      if _allSourcesHidden(sources) then return []

      # If there are multiple sources then we need to build the compound query
      from = for source in sources
        if source.type is 'formula' or source.notInExpression is true
          continue

        timerange = undefined
        if not isSingleSource
          if source.timeUnbound
            bind =
              time: rjqlStringConstants.RJQL_UNBOUND

            if source.hasCustomTimeRange
              timerange = angular.copy source.customTimeRange

              if not timerange.start? and not timerange.end?
                timerange.start = timeRangeEnums.TIME_RANGE_VALUES.START
                timerange.end = timeRangeEnums.TIME_RANGE_VALUES.END

              timerange.field = rjqlStringConstants.RJQL_TIME
          else
            bind = _getTimeBind()

        else if source.by is rjqlStringConstants.RJQL_TIME
          bind = _getTimeBind()

        if rows? and not isSingleSource
          for row, index in rows
            bind[row.name] = source.dimensions[index].column_id

        # Add filters to this source
        where = undefined
        if source.filters?.restrictions.length > 0
          where = _getFilter(source)

        if not showAllGroupByValues and _hasGroupByValueFilters(source.dimensionValues)
          groupByWhere = {}
          for dim, index in source.dimensions
            console.log(dim);
            if _isGa(dim.column_id)
              groupBywhere = _addGaGroupByValueToWhere(groupByWhere, source.dimensionValues[index], dim.column_id)
            else
              groupByWhere = _addGroupByValueToWhere(groupByWhere, source.dimensionValues[index], dim.column_id, version)

        # Once we've built up our groupByWhere expression,
        # add it to the existing where statement
        if groupByWhere?
          where = _mergeWhereStatements(where, groupByWhere)

        # Add ordering and limits
        order = undefined
        if source.order? and timeInterval is timeRangeEnums.TIME_INTERVAL_VALUES.NONE and rows?
          order = source.order

        if isSingleSource
          { metric: source.id, alias: source.alias, timerange, where, order }
        else
          { metric: source.id, alias: source.alias, bind, timerange, where, order }

      if isSingleSource
        from = from[0]

      return from

    # timerange needs to have field set to `:time` if single source
    # and `time` if multi source.
    # For cohort queries (array case) we don't need to change anything
    _generateTimeRange = (sources, timerange, version) ->
      result = angular.copy(timerange)
      isSingleSource = _isSingleSource(sources)

      if timerange? and not Array.isArray(timerange)
        result.field = dataPerspective.getTimeKeyword(isSingleSource)

      result

    _generateRange = (sources, range) ->
      result = angular.copy(range)
      isSingleSource = _isSingleSource(sources)

      unless isSingleSource
        return result

      if sources[0].perspective is "percentOfFirstValueHideFirstValueCohort"
        result.start = 2
      else
        result.start = 1

      result

    # Combine the chart filters with the group by filters
    _mergeWhereStatements = (where, groupByWhere) ->
      # If we have no where, just use the groupByWhere
      unless where?
        return groupByWhere

      # These need to be merged together in a certain way
      # and not mixed throughout the tree
      for key, value of groupByWhere when key isnt 'expression'
        where[key] = value

      where.expression = ["AND", where.expression, groupByWhere.expression]
      return where

    # Checks to see if there are any groupByValue filters that need to be applied
    _hasGroupByValueFilters = (groupByValueLists) ->
      if groupByValueLists?
        for dimensionValues in groupByValueLists
          if Object.keys(dimensionValues).length > 0
            return true
      return false

    # Convert front end filters to RJQL where objects
    _getFilter = (source) ->
      where = {}
      symbols = []
      indicesOfNullsInINClause = []
      numRestrictions = source.filters.restrictions.length
      totalRestrictions = numRestrictions
      for filter, index in source.filters.restrictions when source.type is 'metric'
        isGA4Live = if source.isGA4Live then true else false
        operator = _getOperationSymbol(filter.op, _getColumnType(filter.left.column_id),isGA4Live)

        if (operator is operatorEnums.COMPARISON_OPERATOR_SYMBOLS['IS'] or
            operator is operatorEnums.COMPARISON_OPERATOR_SYMBOLS['IS_NOT']) and filter.right is null
          filter.right = "[NULL]"

        where[ encodedLetterString.indexToAlpha(index) ] =
          field: _formatField(filter.left.column_id)
          operator: operator
          value: filter.right

        totalRestrictions = _removeNullsFromINClause operator, filter, index, where, totalRestrictions, indicesOfNullsInINClause

        symbols.push index
      where.expression = rjqlFormula.evaluateFormulaIfValid( source.filters.sequence.string, symbols, 'filter' )
      if indicesOfNullsInINClause.length > 0
        symbolsWhereNullInIN = indicesOfNullsInINClause.map (index) -> encodedLetterString.indexToAlpha(index)
        where.expression = _makeSpecialOperandForNullInIN(where.expression, symbolsWhereNullInIN, numRestrictions)
      return where

    # if we have a filter like 'foo IN (a,b,NULL)', we want to transform
    # it into 'foo IS NULL OR foo IN (a,b)'. this can arise when we generate
    # scalar RJQL (groupbys are treated as filters), and the category [NULL]
    # has been explicitly selected
    _removeNullsFromINClause = (operator, filter, index, where, numRestrictions, indicesOfNullsInINClause) ->
      if operator is operatorEnums.COMPARISON_OPERATOR_SYMBOLS['IN'] and
        '[NULL]' in filter.right
          filter.right = filter.right.filter (value) -> value isnt '[NULL]'
          if filter.right.length > 0
            where[ encodedLetterString.indexToAlpha(index) ].value = filter.right
            symbol = encodedLetterString.indexToAlpha numRestrictions
            indicesOfNullsInINClause.push index
            numRestrictions += 1
          else
            symbol = encodedLetterString.indexToAlpha index
          where[ symbol ] =
            field: _formatField(filter.left.column_id)
            operator: operatorEnums.COMPARISON_OPERATOR_SYMBOLS['IS']
            value: '[NULL]'

      return numRestrictions

    # recursively traverse an RJQL WHERE expression and replace e.g. [A] with
    # [OR, [A], [X]] for filters that had NULL as an element in an
    # IN clause
    _makeSpecialOperandForNullInIN = (expression, symbolsWhereNullInIN, numRestrictions) ->
      if expression instanceof Array
        for subExpression in expression
          subExpression = _makeSpecialOperandForNullInIN subExpression, symbolsWhereNullInIN, numRestrictions
      else
        indexOfSymbol = symbolsWhereNullInIN.indexOf(expression)
        if indexOfSymbol > -1
          expression = [
            'OR',
            expression,
            encodedLetterString.indexToAlpha(numRestrictions + indexOfSymbol)
          ]
        else
          expression

    _addGroupByValueAlias = (expression, name) ->
      unless expression?
        return name
      return ['AND', expression, name]

    _addGaGroupByValueToWhere = (where, dimensionMap, column_id) ->
      name = '[GROUPBYGAFILTERA]'
      index = 0
      expression = null

      if Object.keys(dimensionMap).length > 0
        dimensionValues = Object.keys(dimensionMap)

        # GA doesn't support IN so we need separate OR'd filters :(
        for dimensionValue in dimensionValues
          # Names need to be unique
          while where[name]?
            name = "[GROUPBYGAFILTER#{encodedLetterString.numToLetter(index)}]"
            index += 1

          where[name] =
            field: _formatField(column_id)
            operator: '=='
            value: dimensionValue

          expression = _mergeExpressions('OR', expression, name)
      # If there are no dimensionValues then we don't need to filter.
      else
        return where

      # Last, we need to add this new expression to the overall
      # expression with an AND
      where.expression = _mergeExpressions('AND', where.expression, expression)

      return where

    _mergeExpressions = (operator, first, second) ->
      expression = null
      if not first?
        expression = second
      else if typeof first is 'string'
        expression = [operator, first, second]
      else if first instanceof Array
        expression = [operator, first, second]

      return expression

    _addGroupByValueToWhere = (where, dimensionMap, column_id, version) ->
      name = '[GROUPBYFILTERA]'
      index = 1
      if column_id is rjqlStringConstants.RJQL_UNBOUND
        return null

      dimensionValues = Object.keys(dimensionMap)
      if dimensionValues.length > 0

        # Names need to be unique
        while where[name]?
          name = "[GROUPBYFILTER#{encodedLetterString.numToLetter(index)}]"
          index += 1

        if '[NULL]' in dimensionValues and version is 1.0
          where[name] =
            field: _formatField(column_id)
            operator: operatorEnums.COMPARISON_OPERATOR_SYMBOLS['IS']
            value: '[NULL]'

          dimensionValuesWithoutNull = dimensionValues.filter((value) -> value isnt '[NULL]')

          if dimensionValuesWithoutNull.length > 0
            name2 = "[GROUPBYFILTER#{encodedLetterString.numToLetter(index)}]"

            where[name2] =
              field: _formatField(column_id)
              operator: 'IN'
              value: dimensionValuesWithoutNull

            where.expression = _addGroupByValueAlias(where.expression, _mergeExpressions('OR', name, name2))
          else
            where.expression = _addGroupByValueAlias(where.expression, name)

        else
          where[name] =
            field: _formatField(column_id)
            operator: 'IN'
            value: dimensionValues
          where.expression = _addGroupByValueAlias(where.expression, name)

      return where

    _isGa = (column_id) ->
      is_string = isNaN(parseInt(column_id))
      return (("#{column_id}".match(/^ga:.*$/)?) || (is_string && !Object.values(rjqlStringConstants).includes(column_id)))

    _getColumnType = (column_id) ->
      if _isGa(column_id) then return 'ga' else return ''

    # Ga dimensions are strings, all others should be ints
    _formatField = (column_id) ->
      # Is this a GA dimension?
      if _isGa(column_id) then return column_id else return +column_id

    # We get names passed in that need to be converted to symbols
    _getOperationSymbol = (name, operationType, isGa4) ->
      if(isGa4)
        operationType = 'ga4'
      switch operationType
        when 'ga'
          return operatorEnums.GA_COMPARISON_OPERATOR_SYMBOLS[name]
        when 'ga4'
          return operatorEnums.GA4_COMPARISON_OPERATOR_SYMBOLS[name]
        else
          return operatorEnums.COMPARISON_OPERATOR_SYMBOLS[name]

    _getQueryUrl = (clientId, version, debug) ->
      switch version
        when 0.1 then phpServiceUrl "/rjql/v0.1/client/#{clientId}/query"
        when 1.0 then serviceUrl("/clients/#{clientId}/rjql/query") + _getDebugFlag(debug)
        else ""

    _getDebugFlag = (debug) ->
      if debug then '?debug=1' else ''

    _isApi = (version) ->
      switch version
        when 0.1 then false
        when 1.0 then true
        else true

    runQuery = (clientId, query, deferred, version=0.1, debug=false) ->
      deferred ?= $q.defer()
      $http
        method: "POST"
        url: _getQueryUrl(clientId, version, debug)
        data: query
        timeout: deferred.promise
        withCredentials: _isApi(version)

    PROMISE_CACHE_STORE_KEY = 'post-rjql-query'
    MAX_AGE_MILLISECONDS = 10 * 60 * 1000 # Expire cached queries after 10 minutes

    runQueryCached = (clientId, query, deferred, version=0.1, debug=false) ->
      deferred ?= $q.defer()
      queryHash = utils.objToHash(query)

      promiseCache.get(
        PROMISE_CACHE_STORE_KEY
        queryHash
        _.partial(
          runQuery,
          clientId,
          query,
          null,
          version,
          debug
        )
        MAX_AGE_MILLISECONDS
      ).then(
        (success) ->
          deferred.resolve(success)
        (failure) ->
          deferred.reject(failure)
      )

      return deferred.promise

    # Handles scalars and compound queries
    # Checks for sources with expressions as formulas
    generateQuery = (sources, rows, columns, timerange, range, showAllGroupByValues=false, version=0.1) ->
      if not Array.isArray(sources)
        throw "generate query only accepts sources as an array"

      return
        select: _generateSelect sources, rows, columns, version
        from: _generateFrom sources, rows, columns, showAllGroupByValues, version
        timerange: if timerange? then _generateTimeRange(sources, timerange, version)
        range: if range? then _generateRange(sources, range)

    {
      generateQuery
      runQuery
      runQueryCached
    }
  ]
